<template>
    <div>
      <div class="home4">
          <div class="title">
            <h6>合作院校</h6>
            <p>Cooperative institutions</p>
          </div>

          <div class="logo">
            <div class="logobox" v-for="item,index in list" :key="index">
              <el-image
            class="xiaoheui"
            :src="imgurl + item.pic"></el-image>
           
            </div>
          </div>

          <div class="lianxi">
            <h6>专注青少年校服文化 陪伴学生幸福成长</h6>
            <p>Focus on youth school uniform culture to accompany students' ha</p>
            <el-row>
              <el-col :xs="0" :sm="24" :md="24" :lg="24" :xl="24">
               <div class="inputs">
                  <el-input size="mini" v-model="input"></el-input>
                  <el-button size="mini" type="warning">Submit</el-button>
                </div>
            
              </el-col>
            </el-row>
            
           
            
          </div>

      </div>
    </div>
</template>
<script>
import { myMixins } from "@/utils/mixin.js";
export default {
  name: 'homeView2',
  mixins: [myMixins],
  props: {
    list: Array
  },
  data(){
    return{
      input:''
    }
  }
}
</script>
<style scoped lang="less">
.home4{
 
  background-image: url(../assets/bj2.png);
  background-size: 100% 100%;
  height: 1400px;
  width: 100%;
 
  .title{
    padding-top: 80px;
    width: 100%;
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h6{
      font-size: 46px;
    }
    p{
      margin-top: 10px;
      font-size: 46px;
      font-family: "微软雅黑";
      font-weight: 200;
    }
  }
  .logo{
    width: 1480px;
    margin: 100px auto;
    display: flex;
    justify-content: center;
    
    flex-wrap: wrap;
    .logobox{
      width: 230px;
      height: 200px;
      background-color: #fff;
      font-size: 10px;
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 20px;
     .xiaoheui{
      width: 120px;
      height: 120px;
     }
    }
  }
  .lianxi{
    background-image: url(../assets/get.png);
      background-size: 100% 100%;
    width: 1580px;
    height: 500px;
    // background-color: #016F62;
    border-radius: 20px;
    margin: 20px auto 30px;
    display: flex;
    color: #fff;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    h6{
      font-size: 46px;
    }
    p{
      margin: 20px 0;
      font-size: 22px;
    }
    .inputs{
      display: flex;
      align-items: center;
      .el-input{
            width: 500px;
            margin-right: 20px;
          }
      
    }
  }

}


</style>     